import React from "react";
import { Box, Typography, Fade, Grow } from "@mui/material";
import {
  Email,
  Phone,
  LocationOn,
  LinkedIn,
  GitHub,
  ContactSupport,
} from "@mui/icons-material";
import styled from "styled-components";

const ContactMethod = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
  margin: 0.5rem 0;
  border-radius: 12px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(0, 102, 204, 0.05);
    transform: translateX(8px);
  }
`;

const ContactIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0066cc 0%, #008cff 100%);
  color: white;
  margin-right: 1rem;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

function ContactMethods() {
  const contactMethods = [
    {
      icon: <Email />,
      title: "Email",
      value: "coryevansmith@gmail.com",
      link: "mailto:coryevansmith@gmail.com",
      description: "Send me a direct email",
    },
    {
      icon: <Phone />,
      title: "Phone",
      value: "682-557-6391",
      link: "tel:+16825576391",
      description: "Call me directly",
    },
    {
      icon: <LocationOn />,
      title: "Location",
      value: "Arlington, Texas",
      link: "#",
      description: "Based in the Dallas-Fort Worth area",
    },
    {
      icon: <LinkedIn />,
      title: "LinkedIn",
      value: "linkedin.com/in/coryevansmith",
      link: "https://www.linkedin.com/in/coryevansmith/",
      description: "Connect professionally",
    },
    {
      icon: <GitHub />,
      title: "GitHub",
      value: "github.com/coryevansmith",
      link: "https://github.com/coryevansmith",
      description: "View my code projects",
    },
  ];

  return (
    <Fade in timeout={1200}>
      <Box>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: 600,
            mb: 4,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <ContactSupport sx={{ color: "#0066CC" }} />
          Information
        </Typography>

        <Typography
          variant="body1"
          sx={{ mb: 4, color: "#666", lineHeight: 1.6 }}
        >
          I'm always open to discussing new opportunities, interesting projects,
          or just having a friendly conversation about technology and
          development.
        </Typography>

        {contactMethods.map((method, index) => (
          <Grow in timeout={1300 + index * 100} key={method.title}>
            <ContactMethod>
              <ContactIcon>{method.icon}</ContactIcon>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                  {method.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 0.5 }}
                >
                  {method.description}
                </Typography>
                <Typography
                  variant="body1"
                  component="a"
                  href={method.link}
                  sx={{
                    color: "#0066CC",
                    textDecoration: "none",
                    fontWeight: 500,
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  {method.value}
                </Typography>
              </Box>
            </ContactMethod>
          </Grow>
        ))}
      </Box>
    </Fade>
  );
}

export default ContactMethods;
